// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-settings-control {
  display: flex;
  flex-direction: column;
}

.model-settings-control-buttons {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  justify-content: flex-end;
  position: absolute;
  top: calc(var(--dialog-padding) / 2);
  right: calc(var(--dialog-padding) / 2);
}

.model-settings-control-title {
  font-size: var(--font-size-l);
  font-weight: bold;
  padding: calc(var(--dialog-padding) / 2);
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  align-items: center;
  border-bottom: 1px solid var(--border-color);
}

.model-settings-control-title-text {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
}

.model-settings-control-content {
  display: flex;
  flex-direction: column;
  gap: var(--input-element-gap);
  padding: calc(var(--dialog-padding) / 2) var(--dialog-padding) var(--dialog-padding) var(--dialog-padding);
  min-height: 465px; /* TODO: Find better solution */
  box-sizing: border-box;
}

.model-settings-control-content-row {
  display: flex;
  flex-direction: column;
  gap: var(--input-element-gap);

  > div {
    display: flex;
    flex-direction: row;
    gap: var(--input-element-gap);
    align-items: center;
    justify-content: space-between;
  }
}

.model-settings-control-content-row-title {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  align-items: center;

  > span {
    font-weight: bold;
  }
}

.scale-button-inactive > svg {
  color: var(--text-color);
}

.scale-button-active > svg {
  color: var(--info-color);
}

.model-settings-control-content-row-textbutton {
  cursor: pointer;
}

.model-settings-control-content-row-textbutton-active {
  font-weight: bold;
}

.model-settings-control-row-separator {
  width: 100%;
  height: 1px;
  background-color: var(--border-color);
  margin-bottom: var(--input-element-gap);
  margin-top: calc(var(--input-element-gap) * 2);
}

.model-settings-control-content-tabbar {
  display: flex;
  flex-direction: row;
  gap: var(--input-element-gap);
  align-items: center;
  padding: calc(var(--dialog-padding) / 2);
  border-bottom: 1px solid var(--border-color);
  font-size: var(--font-size-l);
}

.model-settings-control-content-tabbar-tab {
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  padding: 0 var(--input-element-gap);
  border-radius: var(--dialog-border-radius);
  color: var(--text-color-inactive);
  font-size: var(--font-size-l);
  margin: 0 auto;
}

.model-settings-control-content-tabbar-tab:hover {
  background-color: var(--extra-light-grey);
  color: var(--text-color);
}

.model-settings-control-content-tabbar-tab-active {
  color: var(--text-color);
  text-decoration: underline;
}

.model-settings-control-content-row .toggle-switch {
  margin-bottom: var(--input-element-gap);
}

.model-settings-control-content-row input[type="range"] {
  height: unset;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/model-settings-control/ModelSettingsControl.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,0GAA0G;EAC1G,iBAAiB,EAAE,+BAA+B;EAClD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;;EAE7B;IACE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;;EAEnB;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,mCAAmC;EACnC,0CAA0C;EAC1C,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".model-settings-control {\n  display: flex;\n  flex-direction: column;\n}\n\n.model-settings-control-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  justify-content: flex-end;\n  position: absolute;\n  top: calc(var(--dialog-padding) / 2);\n  right: calc(var(--dialog-padding) / 2);\n}\n\n.model-settings-control-title {\n  font-size: var(--font-size-l);\n  font-weight: bold;\n  padding: calc(var(--dialog-padding) / 2);\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  align-items: center;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.model-settings-control-title-text {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-grow: 1;\n}\n\n.model-settings-control-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--input-element-gap);\n  padding: calc(var(--dialog-padding) / 2) var(--dialog-padding) var(--dialog-padding) var(--dialog-padding);\n  min-height: 465px; /* TODO: Find better solution */\n  box-sizing: border-box;\n}\n\n.model-settings-control-content-row {\n  display: flex;\n  flex-direction: column;\n  gap: var(--input-element-gap);\n\n  > div {\n    display: flex;\n    flex-direction: row;\n    gap: var(--input-element-gap);\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.model-settings-control-content-row-title {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  align-items: center;\n\n  > span {\n    font-weight: bold;\n  }\n}\n\n.scale-button-inactive > svg {\n  color: var(--text-color);\n}\n\n.scale-button-active > svg {\n  color: var(--info-color);\n}\n\n.model-settings-control-content-row-textbutton {\n  cursor: pointer;\n}\n\n.model-settings-control-content-row-textbutton-active {\n  font-weight: bold;\n}\n\n.model-settings-control-row-separator {\n  width: 100%;\n  height: 1px;\n  background-color: var(--border-color);\n  margin-bottom: var(--input-element-gap);\n  margin-top: calc(var(--input-element-gap) * 2);\n}\n\n.model-settings-control-content-tabbar {\n  display: flex;\n  flex-direction: row;\n  gap: var(--input-element-gap);\n  align-items: center;\n  padding: calc(var(--dialog-padding) / 2);\n  border-bottom: 1px solid var(--border-color);\n  font-size: var(--font-size-l);\n}\n\n.model-settings-control-content-tabbar-tab {\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n  padding: 0 var(--input-element-gap);\n  border-radius: var(--dialog-border-radius);\n  color: var(--text-color-inactive);\n  font-size: var(--font-size-l);\n  margin: 0 auto;\n}\n\n.model-settings-control-content-tabbar-tab:hover {\n  background-color: var(--extra-light-grey);\n  color: var(--text-color);\n}\n\n.model-settings-control-content-tabbar-tab-active {\n  color: var(--text-color);\n  text-decoration: underline;\n}\n\n.model-settings-control-content-row .toggle-switch {\n  margin-bottom: var(--input-element-gap);\n}\n\n.model-settings-control-content-row input[type=\"range\"] {\n  height: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
